export default "__VITE_ASSET__BtTnBTIS__"